import { useQuery } from '@tanstack/react-query';
import { ProductRankingFilters } from '@/services/benchmark/types';
import { calculateProductPriceAdvantages } from '@/services/benchmark/productRanking';
import {
  calculateDistributionCenterRankings,
  calculateSupermarketRankings,
  calculateOverallMarketRankings,
  calculateConsistencyRankings,
  calculateVolumeOpportunityRankings,
} from '@/services/benchmark/rankingCalculations';

export const useProductPriceAdvantages = (filters: ProductRankingFilters) => {
  const rankingType = filters.marketGroup === 'overall' ? 'overall' :
                     filters.marketGroup === 'consistency' ? 'consistency' :
                     filters.marketGroup === 'volume' ? 'volume' :
                     filters.marketGroup === 'supermarket' ? 'supermarket' :
                     'distribution-center';

  return useQuery({
    queryKey: ['product-rankings', rankingType, filters],
    queryFn: () => {
      const baseFilters = {
        products: filters.products,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        frequency: filters.frequency,
        comparisonType: filters.comparisonType,
        minDaysData: filters.minDaysData,
      };

      switch (rankingType) {
        case 'supermarket':
          return calculateSupermarketRankings(baseFilters);
        case 'overall':
          return calculateOverallMarketRankings(baseFilters);
        case 'consistency':
          return calculateConsistencyRankings(baseFilters);
        case 'volume':
          return calculateVolumeOpportunityRankings(baseFilters);
        case 'distribution-center':
        default:
          return calculateDistributionCenterRankings(baseFilters);
      }
    },
    enabled: filters.products.length > 0 && !!filters.marketGroup,
  });
};
